import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { CustomerFeature } from '@app/core/models/customer.models';

import { CustomerState } from '@app/core/store/states/customer/customer.state';
import { getRawQueryParams } from '@app/core/utilities/url.utilities';
import { environment } from '@env/environment';
import { select } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class GoalsFeatureGuardService implements CanActivate {
  readonly customer = select(CustomerState.customer);

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (!environment.production) return true;
    const v1Path = 'goals';
    const v2Path = 'pg-goals';
    const { path } = route.routeConfig;
    const supportsGoalsV2 = this.customer().features.includes(CustomerFeature.Goalsv2);
    return (
      (supportsGoalsV2 ? path === v2Path : path === v1Path) ||
      this.router.createUrlTree([supportsGoalsV2 ? v2Path : v1Path], { queryParams: getRawQueryParams() })
    );
  }
}
